import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Approve from '@wix/da-ds/pkg/Icons/24x24/Approve';
import verificationReminderStyles from './VerificationReminder.scss';

export interface Props {
  email: string;
}

export const VerificationResent: React.FC<Props> = ({ email }) => {
  const { t } = useTranslation();
  return (
    <div
      className={classnames(verificationReminderStyles['root'], verificationReminderStyles['sent'])}
    >
      <div className={verificationReminderStyles['check']}>
        <Approve customSizable />
      </div>
      <div className={verificationReminderStyles['text']}>{t('siteHeader.verification.sent')}</div>
      <div className={verificationReminderStyles['email']} title={email}>
        {email}
      </div>
    </div>
  );
};
VerificationResent.displayName = 'VerificationResent';

export default VerificationResent;
